import { useLayoutEffect, useMemo } from 'react'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'
import { setCommonTrackingParameters } from '../../../tracking/tracking'
import { getAiDataExtractionBannerExperimentState } from '../../../utils/features/aiDataExtractionBannerExperiment'

export function useAiDataExtractionBannerExperimentTracking(isAiDataExtractionBannerSupported: boolean) {
  const { isActive: isAiDataExtractionBannerEnabled } = useFeatureSwitch(
    FeatureSwitch.PPA_12241_AI_DATA_EXTRACTION_BANNER
  )

  const trackingParameters = useMemo(
    () =>
      getAiDataExtractionBannerExperimentState(isAiDataExtractionBannerSupported, isAiDataExtractionBannerEnabled)
        .trackingParameters,
    [isAiDataExtractionBannerSupported, isAiDataExtractionBannerEnabled]
  )

  useLayoutEffect(() => {
    if (!trackingParameters) return

    setCommonTrackingParameters(trackingParameters)

    return () => {
      setCommonTrackingParameters()
    }
  }, [trackingParameters])
}
